import { combineReducers } from 'redux';

import commonReducer from './reducers/common';
import jobMetricsReducer from './reducers/jobMetrics';
import metricHistoryReducer from './reducers/metricHistory';
import selectedBaselineJobReducer from './reducers/selectedBaselineJob';

const reducers = {
  common: commonReducer,
  jobMetrics: jobMetricsReducer,
  metricHistory: metricHistoryReducer,
  selectedBaselineJob: selectedBaselineJobReducer,
};

export default combineReducers(reducers);
